import { render, staticRenderFns } from "./MinimalDocumentDetails.vue?vue&type=template&id=1c24e3b3&scoped=true"
import script from "./MinimalDocumentDetails.vue?vue&type=script&lang=ts"
export * from "./MinimalDocumentDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c24e3b3",
  null
  
)

export default component.exports